var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgConfiguration = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 2C8.44772 2 8 2.44772 8 3V37C8 37.5523 8.44772 38 9 38H31C31.5523 38 32 37.5523 32 37V3C32 2.44772 31.5523 2 31 2H9ZM11 4C10.4477 4 10 4.44772 10 5V35C10 35.5523 10.4477 36 11 36H29C29.5523 36 30 35.5523 30 35V5C30 4.44772 29.5523 4 29 4H11Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.1429 7H16.8571C16.3831 7 16 7.448 16 8C16 8.552 16.3831 9 16.8571 9H27.1429C27.6169 9 28 8.552 28 8C28 7.448 27.6169 7 27.1429 7Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.1429 13H16.8571C16.3831 13 16 13.448 16 14C16 14.552 16.3831 15 16.8571 15H27.1429C27.6169 15 28 14.552 28 14C28 13.448 27.6169 13 27.1429 13Z",
  fill: "currentColor"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M27.1429 19H16.8571C16.3831 19 16 19.448 16 20C16 20.552 16.3831 21 16.8571 21H27.1429C27.6169 21 28 20.552 28 20C28 19.448 27.6169 19 27.1429 19Z",
  fill: "currentColor"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.1429 25H16.8571C16.3831 25 16 25.447 16 26C16 26.553 16.3831 27 16.8571 27H27.1429C27.6169 27 28 26.553 28 26C28 25.447 27.6169 25 27.1429 25Z",
  fill: "currentColor"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3333 7H12.6667C12.298 7 12 7.448 12 8C12 8.552 12.298 9 12.6667 9H13.3333C13.702 9 14 8.552 14 8C14 7.448 13.702 7 13.3333 7Z",
  fill: "currentColor"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3333 13H12.6667C12.298 13 12 13.448 12 14C12 14.552 12.298 15 12.6667 15H13.3333C13.702 15 14 14.552 14 14C14 13.448 13.702 13 13.3333 13Z",
  fill: "currentColor"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3333 19H12.6667C12.298 19 12 19.448 12 20C12 20.552 12.298 21 12.6667 21H13.3333C13.702 21 14 20.552 14 20C14 19.448 13.702 19 13.3333 19Z",
  fill: "currentColor"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3333 25H12.6667C12.298 25 12 25.447 12 26C12 26.553 12.298 27 12.6667 27H13.3333C13.702 27 14 26.553 14 26C14 25.447 13.702 25 13.3333 25Z",
  fill: "currentColor"
})));
export default SvgConfiguration;